import { useEffect, useRef } from 'react';
export const useAutoOpenPopover = (shouldOpen, setAnchorEl)=>{
    const anchorRef = useRef(null);
    const didOpen = useRef(false);
    useEffect(()=>{
        if (!didOpen.current && shouldOpen && anchorRef.current != null) {
            didOpen.current = true;
            setAnchorEl(anchorRef.current);
        }
    }, [
        shouldOpen,
        setAnchorEl
    ]);
    return anchorRef;
};
